export default __webpack_public_path__ + "static/media/starClosed.svg";